import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { NgxAimAddFflClass } from './ngx-aim-add-ffl.class';

@Component({
  selector: 'ngx-aim-add-ffl',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
  ],
  templateUrl: './ngx-aim-add-ffl.component.html',
  styleUrls: ['./ngx-aim-add-ffl.component.css']
})
export class NgxAimAddFflComponent extends NgxAimAddFflClass implements OnInit {
  ngOnInit() {
    this.init();
  }
}
